import { cn } from "@/lib";

interface TProps {
    isSelected: boolean;
    value: string;
    onClick: () => void;
}

const CategoryButton = ({isSelected, value, onClick}: TProps) => {
    return(
        <div className={cn("text-nowrap uppercase border rounded-2xl px-4 py-1 text-sm font-semibold text-gray-500", isSelected && "text-white bg-primary")} onClick={onClick}>
            {value}
        </div>
    );
}

export default CategoryButton;